// LogoMark - Sprint 44 XL Branding.
// Logo minimalista de StockPilot ERP: caja + check incrustado, con un halo
// superior que sugiere "guia/piloto". SVG inline, sin assets externos.
// Soporta color (toma currentColor), tamano y animacion (rotacion suave).
//
// Uso:
//   <LogoMark size={28} />
//   <LogoMark size={64} animated />
//   <LogoMark monochrome />   // fuerza currentColor en todo el logo
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../design/motion';

const CSS_ID = 'xl-logo-css';
const CSS = `
@keyframes xl-logo-orbit {
  from { transform: rotate(0deg) }
  to   { transform: rotate(360deg) }
}
.xl-logo {
  display: inline-block;
  color: var(--xl-color-primary);
  vertical-align: middle;
  line-height: 0;
}
.xl-logo svg { display: block }
.xl-logo--animated .xl-logo__halo {
  transform-origin: 32px 32px;
  animation: xl-logo-orbit 14s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .xl-logo--animated .xl-logo__halo { animation: none }
}
`;

export default function LogoMark({
  size = 32,
  monochrome = false,
  animated = false,
  className = '',
  title = 'StockPilot',
}) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const boxFill     = monochrome ? 'currentColor' : 'var(--xl-color-primary)';
  const boxStroke   = monochrome ? 'currentColor' : 'var(--xl-color-primary-hover)';
  const accentFill  = monochrome ? 'currentColor' : 'var(--xl-color-secondary)';
  const haloStroke  = monochrome ? 'currentColor' : 'var(--xl-color-primary)';

  const cls = [
    'xl-logo',
    animated ? 'xl-logo--animated' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={cls} role="img" aria-label={title} title={title}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="xl-logo__halo">
          <circle
            cx="32" cy="32" r="28"
            fill="none"
            stroke={haloStroke}
            strokeOpacity="0.18"
            strokeWidth="2"
            strokeDasharray="5 7"
          />
        </g>
        {/* Caja principal */}
        <path
          d="M14 20 L32 12 L50 20 L50 44 L32 52 L14 44 Z"
          fill={boxFill}
          stroke={boxStroke}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        {/* Linea interior (top aristas del prisma) */}
        <path
          d="M14 20 L32 28 L50 20 M32 28 L32 52"
          fill="none"
          stroke="rgba(255,255,255,0.55)"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        {/* Check verde marcando "aprobado/listo" */}
        <path
          d="M24 33 L30 39 L42 27"
          fill="none"
          stroke={accentFill}
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
